import type { ApiItem } from "./api.ts";

type PricedItem = Pick<
    ApiItem,
    "priceCents" | "salePriceCents"
>;

function createVisibleAmount(
    elementName: "span" | "s",
    className: string,
    value: string,
): HTMLElement {
    const element = document.createElement(elementName);
    element.className = className;
    element.textContent = value;
    element.setAttribute("aria-hidden", "true");

    return element;
}

export function renderPrice(
    container: HTMLElement,
    item: PricedItem,
    formatter: Intl.NumberFormat,
): void {
    container.replaceChildren();
    container.removeAttribute("aria-label");

    if (item.priceCents === null) {
        container.hidden = true;
        return;
    }

    container.hidden = false;

    const regularValue = formatter.format(
        item.priceCents / 100,
    );

    if (item.salePriceCents === null) {
        container.setAttribute(
            "aria-label",
            `Price: ${regularValue}`,
        );
        container.append(
            createVisibleAmount(
                "span",
                "price__regular",
                regularValue,
            ),
        );
        return;
    }

    const saleValue = formatter.format(
        item.salePriceCents / 100,
    );

    container.setAttribute(
        "aria-label",
        `Regular price: ${regularValue}. Sale price: ${saleValue}.`,
    );

    container.append(
        createVisibleAmount(
            "s",
            "price__regular price__regular--discounted",
            regularValue,
        ),
        createVisibleAmount(
            "span",
            "price__sale",
            saleValue,
        ),
    );
}
